import React from 'react';
import { Loader } from '../../components/loader/Loader';
import { useAssetClass } from '../../contexts/assetClass';
import { TaskServiceDeskCreate } from './ServiceDesk/Create/TaskServiceDeskCreate';
import { TasksNew } from './TasksNew';

export const TasksNewRedirect = () => {
  const { assetGuiVersion } = useAssetClass();

  if (assetGuiVersion === undefined) return <Loader />;
  if (assetGuiVersion === 0) return <TasksNew />;
  if (assetGuiVersion === 1) return <TaskServiceDeskCreate />;
};
